import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
  max-width: 1100px;
  margin: 0 auto;
  font-family: Arial, Helvetica, sans-serif;
`;

export const GroupRow = styled.div`
  display: grid;
  grid-template-columns: 96px 1fr 340px;
  border-radius: 16px;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);

  @media (max-width: 860px) {
    grid-template-columns: 96px 1fr;
    grid-template-rows: auto auto;
    grid-auto-flow: row;
  }
`;

export const GroupName = styled.div<{ color: string }>`
  background: ${p => p.color};
  color: #fff;
  writing-mode: vertical-rl;
  transform: rotate(180deg);
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 800;
  font-size: 1.05rem;
  letter-spacing: 0.5px;
  text-align: center;
  padding: 1rem 0.25rem;
  margin-right: 0.5rem;
`;

export const GroupQuestions = styled.div<{ bg: string }>`
  background: ${p => p.bg};
  padding: 1.2rem 1.5rem;
  display: flex;
  flex-direction: column;
  gap: 1rem;
  margin-right: 0.5rem;
`;

export const GroupSliders = styled.div<{ bg: string }>`
  background: ${p => p.bg};
  padding: 1.2rem 1.5rem;
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;

export const QuestionText = styled.div`
  font-size: 1rem;
  line-height: 1.45;
  color: #222;
`;

export const Separator = styled.div<{ color: string }>`
  height: 2px;
  width: 100%;
  background: ${p => p.color};
  border-radius: 2px;
  opacity: 0.9;
`;

export const SliderBar = styled.div`
  position: relative;
  height: 14px;
  border-radius: 9px;
  background: repeating-linear-gradient(
    to right,
    #58a543 0%,
    #58a543 25%,
    // #92ad25 25%,
    // #92ad25 40%,
    #decd1b 25%,
    #decd1b 50%,
    #df841b 50%,
    #df841b 75%,
    #d23525 75%,
    #d23525 100%
  );
`;

export const SliderMarker = styled.div<{ position: number }>`
  position: absolute;
  top: 50%;
  left: ${p => p.position}%;
  transform: translate(-50%, -50%);
  width: 18px;
  height: 18px;
  border: 4px solid #fff;
  border-radius: 50%;
  background: transparent;
  box-shadow: 0 0 4px rgba(0, 0, 0, 0.35);
  transition: left 0.3s ease;

  &:hover::after {
    content: attr(data-value);
    position: absolute;
    top: -28px;
    left: 50%;
    transform: translateX(-50%);
    background: #333;
    color: #fff;
    font-size: 0.75rem;
    padding: 4px 6px;
    border-radius: 4px;
    white-space: nowrap;
    pointer-events: none;
  }
`;

export const ScaleLabels = styled.div`
  display: flex;
  justify-content: space-between;
  font-size: 0.85rem;
  margin-top: 0.35rem;
  color: #666;
`;
